import { Directive, HostListener, Injectable, Input } from '@angular/core';

import { BsModalRef } from 'ngx-bootstrap/modal';

import { SelectItem } from '@bn/primitives';

import { AbstractModalDirective } from '../../../dialog/abstracts';
import { ModalState } from '../../models/modal-state.model';

import { BnSelectInputDialogComponent } from './select-input-dialog.component';

@Directive({
  selector: '[bnWebUiSelectInputDialogDirective]',
})
@Injectable({
  providedIn: 'root',
})
export class SelectInputDialogDirective extends AbstractModalDirective {
  constructor() {
    super();
  }

  @Input()
  parentEntity?: unknown;

  @Input()
  selectItems!: SelectItem[];

  @Input()
  existingItemId?: SelectItem['Id'];

  @Input()
  settings!: ModalState;

  @HostListener('click', ['$event'])
  clicked(event: Event): void {
    event.preventDefault();
    this.openDialog(this.settings, this.parentEntity, this.selectItems, this.existingItemId);
  }

  openDialog(settings: ModalState, parentEntity: unknown, selectItems: SelectItem[] = [], existingItemId?: SelectItem['Id']): BsModalRef {
    this.bsModalRef = this.modalService.show(BnSelectInputDialogComponent, {
      class: 'modal-dialog-centered modal-sm',
      initialState: {
        dataIn: {
          confirmButtonName: settings.confirmButtonName,
          contextType: settings.contextType,
          description: settings.description,
          icon: settings.icon,
          input: settings.input,
          item: existingItemId,
          items: selectItems,
          parentEntity,
          textCenter: true,
          title: settings.title,
          virtualScrollConfig: settings.virtualScrollConfig,
        },
      },
    });

    return this.bsModalRef;
  }
}
